import { defineFieldFormInterface } from "~/entities/field";
import ImageInterface from "./ImageInterface.vue";

export default defineFieldFormInterface({
  interface: "file-image",
  component: ImageInterface,
});
